var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"club-about",domProps:{"innerHTML":_vm._s(_vm.company.club_about)}}),_c('UserClubProfileFooter',{attrs:{"serverVersion":_vm.serverVersion},on:{"openSupportModal":function($event){return _vm.$emit('openSupportModal')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }